import sendToVend from './vendMessages';
import axios from 'axios'
import Router from './../router';
import { printSignatureReceipt } from "./signatureReceipt";

function pollTerminal(response) {
    axios({
        method: "GET",
        url: "https://uk1.storekitpayments.com/api/v1/pay-at-counter/terminals/" + process.env.VUE_APP_TID + "/transactions/" + response.data.result.transaction_id,
        headers: {'Authorization': 'Basic dGVzdDp0ZXN0'},
        })
        .then(function (pollingResponse) {
            console.log(pollingResponse.data.result.device_notifications.slice(-1)[0])
            if (pollingResponse.data.result.payment_method === "SWIPED" || pollingResponse.data.result.device_notifications.slice(-1)[0] === "SIGNATURE_VERIFICATION") {
                Router.push({ path: '/signature', query: { tid: pollingResponse.data.result.tid, transactionId: pollingResponse.data.result.id } });
                printSignatureReceipt(pollingResponse, true);
                // setTimeout( ()=> {
                //     pollTerminal(response)
                // }, 1000)
            }
            else {
                let transactionFinished = isTransactionComplete(pollingResponse);
                if (transactionFinished) {
                    if (pollingResponse.data.result.transaction_result === "SUCCESSFUL" && pollingResponse.data.result.device_notifications.slice(-1)[0] !== "SIGNATURE_VERIFICATION") {
                        sendToVend('ACCEPT', pollingResponse);
                        Router.push('/success');
                    }
                    else if (pollingResponse.data.result.transaction_result === "TIMED_OUT" || pollingResponse.data.result.transaction_result === "CANCELLED_BY_USER") {
                        Router.push('/timed-out');
                    }
                    else {
                        Router.push('/failed');
                    }
                }
                else if (pollingResponse.data.result.transaction_result === "PENDING") {
                    Router.push({ path: '/pending', query: { status: pollingResponse.data.result.device_notifications.slice(-1)[0] }});
                    setTimeout(()=> {
                        pollTerminal(response)
                    },500)
                }
                else {
                    setTimeout(()=> {
                        pollTerminal(response)
                    },1000)
                }
            }

        })
        .catch(function (e) {
            console.log(e);
        });
}

function isTransactionComplete(pollingResponse) {
    return pollingResponse.data.result.transaction_result === "APPROVED" || pollingResponse.data.result.transaction_result === "TIMED_OUT" || pollingResponse.data.result.device_notifications.slice(-1)[0] === "TRANSACTION_FINISHED";
}

export default pollTerminal;
